// @flow

import { type UserInputName } from '@tectonics/prs/user-input';
import { useValidation } from './use-validation';
import { type UserInputValidationError } from './types';

export function useUserInputValidationError(userInputName: UserInputName): ?UserInputValidationError {
  const validation = useValidation();
  return validation.userInputValidationErrors[userInputName];
}
